<form class="universal-book-fetch" (submit)="fetch()">
    <div class="form-group">
        <label for="url">Link to Book Retailer (Amazon, Apple, etc...) <span class="required">*</span>
            <app-tooltip-card
                  label="?"
                  [text]="tooltipText">
            </app-tooltip-card>
        </label>
        <div class="flex">
            <input (blur)="fetch()" id="url" name="url" type="url" [(ngModel)]="url">
            <button (click)="fetch()">Go</button>
        </div>
    </div>
</form>
<app-new-error-modal [options]="errorOptions" modalId="universal-link-error"></app-new-error-modal>
